export default "__VITE_ASSET__kfjV17_I__"